/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import {Fragment, useCallback, useEffect, useRef, useState} from 'react'
import {Box, Button, Divider, Link, Menu, MenuItem, Slide, useTheme} from '@mui/material'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import {useNavigate, useLocation} from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import {ENDPOINT} from 'config/path'
import Chevron from 'assets/images/normal_chevron-booking.svg'
import Chevron1 from 'assets/images/selected_chevron-booking.svg'
import {cpsUrl} from 'config/base'

interface MenuColectionProps {
    publicPathName?: unknown[]
}

const MenuColection = (props: MenuColectionProps) => {
    const {publicPathName} = props
    const location = useLocation()
    const [menuOpen, setMenuOpen] = useState(false)
    const [isMobileSubMenuOpen, setIsMobileSubMenuOpen] = useState(false)

    const navigate = useNavigate()

    const menuItems = [
        {
            id: 1,
            name: 'Why CPS',
            goto: '#why-cps'
        },
        {
            id: 2,
            name: 'Special deals',
            goto: '#specialDealsMainContainer'
        },
        {
            id: 3,
            name: 'Get help',
            goto: '#blog-help'
        }
    ]
    const subMenuItems = [
        {
            id: 1,
            name: 'For freight forwarders',
            goto: '#FreightForwardersVideo'
        },
        {
            id: 2,
            name: 'For airlines',
            goto: '#AirlineVideo'
        }
    ]

    useEffect(() => {}, [location.pathname])
    const handleRegistrationClick = () => {
        setMenuOpen(false)
        // navigate(ENDPOINT.register, {state: {preselectBranchOption: true}})
         window.location.href = `${cpsUrl}${ENDPOINT.register}`
    }

    const handleLoginClick = () => {
        setMenuOpen(false)
        window.location.href = `${cpsUrl}/cpsreact${ENDPOINT.login}`
    }

    const handleMenuClick = (e, sectionId) => {
        if (sectionId === '#blog-help') {
            setMenuOpen(false)
            window.location.href = `${cpsUrl}${ENDPOINT.contactExistingCPS}`
        } else if (sectionId === '#why-cps') {
            setIsMobileSubMenuOpen(true)
        } else {
            if (!location.pathname.toLowerCase().includes(ENDPOINT.homepage)) {
                navigate(ENDPOINT.homepage)
            }
            e.preventDefault()
            setTimeout(() => {
                setMenuOpen(false)
                const targetSection = document.querySelector(sectionId) as HTMLElement
                const offset = 80
                if (targetSection) {
                    const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset
                    window.scrollTo({
                        top: targetPosition - offset,
                        behavior: 'smooth'
                    })
                }
            }, 20)
        }
    }

    const handleMenuIconClick = () => {
        setMenuOpen(!menuOpen)
    }
    const subMenusNodes = subMenuItems?.map((subMenuItem) => (
        <MenuItem
            onClick={(e: any) => {
                if (window.pageYOffset <= 0) {
                    window.scrollTo({
                        top: 1000
                    })
                }
                handleMenuClick(e, subMenuItem.goto)
            }}
            key={subMenuItem.name}
            sx={{
                padding: '8px 16px',
                '&:hover': {backgroundColor: 'white', color: '#356eab'}
            }}
        >
            {subMenuItem.name}
        </MenuItem>
    ))
    const [dropDownYN, setdropDownYN] = useState(false)
    const showSubMenu = useCallback(() => {
        setdropDownYN(true)
    }, [])
    const closeSubMenu = useCallback(() => {
        setdropDownYN(false)
    }, [])
    const toggleSubMenu = useCallback(
        (arg) => (event) => {
            setIsMobileSubMenuOpen(arg)
        },
        []
    )
    const buttonRef = useRef<null | HTMLButtonElement>(null)
    const theme = useTheme()

    return (
        <>
            {(location.pathname.includes(ENDPOINT.homepage) ||
                publicPathName?.some((item: any) => location.pathname.toLowerCase().includes(item.toLowerCase()))) && (
                <div className='menu-container1 alignLeft hide-menu-container'>
                    {menuItems.map((item, index) => (
                        <Fragment key={index}>
                            <Box
                                ref={buttonRef}
                                tabIndex={0}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                        if (item.name === 'Why CPS') {
                                            showSubMenu()
                                        } else {
                                            handleMenuClick(event, item.goto)
                                        }
                                    }
                                }}
                                className='menuText1'
                                onClick={(e: any) => {
                                    if (!(item.name === 'Why CPS')) {
                                        handleMenuClick(e, item.goto)
                                    }
                                }}
                                onMouseLeave={() => {
                                    if (item.name === 'Why CPS') {
                                        closeSubMenu()
                                    }
                                }}
                                onMouseEnter={() => {
                                    if (item.name === 'Why CPS') {
                                        showSubMenu()
                                    }
                                }}
                                sx={{
                                    zIndex: theme.zIndex.modal + 1
                                }}
                            >
                                {item.name}
                                {item.name === 'Why CPS' && (
                                    <Box id='ExpandIcon'>
                                        {dropDownYN ? (
                                            <img src={Chevron1} className='ExpandMore' alt='ExpandMoreIcon' />
                                        ) : (
                                            <img src={Chevron} className='ExpandLess' alt='ExpandLessIcon' />
                                        )}
                                    </Box>
                                )}
                            </Box>
                            <Menu
                                id='HomepageSubMenu'
                                className='DropdownMenu'
                                PaperProps={{
                                    onMouseEnter: () => {
                                        showSubMenu()
                                    },
                                    onMouseLeave: () => {
                                        closeSubMenu()
                                    },
                                    style: {
                                        borderLeft: '5px solid',
                                        WebkitBorderImage: '-webkit-linear-gradient(bottom,  #32936f, #a1e8af) 1 100%',
                                        padding: 0,
                                        margin: 0
                                    }
                                }}
                                anchorEl={buttonRef.current}
                                open={dropDownYN}
                                onClose={closeSubMenu}
                                disableAutoFocusItem
                                disableScrollLock
                                disablePortal
                            >
                                {subMenusNodes}
                            </Menu>
                        </Fragment>
                    ))}
                </div>
            )}
            <div
                className={
                    location.pathname.includes(ENDPOINT.viewSchedule) ||
                    location.pathname.includes(ENDPOINT.trackShipment) ||
                    location.pathname.includes(ENDPOINT.viewFlightStatus) ||
                    location.pathname.includes(ENDPOINT.contactCPS) ||
                    location.pathname.includes(ENDPOINT.faqpage)
                        ? 'menu-container2 hide-menu-container justify-end jusify-login-btn'
                        : 'menu-container2 hide-menu-container justify-end'
                }
            >
                {publicPathName?.some((item: any) => location.pathname.toLowerCase().includes(item.toLowerCase())) && (
                    <Link component='button' onClick={handleLoginClick} className='goToLogin'>
                        <AccountCircleIcon className='login-icon' />
                        <span className='loginTxt'>Log in</span>
                    </Link>
                )}
                <Button className='registrationBtn' onClick={() => handleRegistrationClick()}>
                    Register
                </Button>
            </div>
            <div className={location.pathname.includes(ENDPOINT.faqpage) ? 'btn-container' : 'btn-container add-width'}>
                {publicPathName?.some((item: any) => location.pathname.toLowerCase().includes(item.toLowerCase())) && (
                    <div className='icon-button' onClick={handleMenuIconClick}>
                        {menuOpen ? <CloseIcon className='icon' /> : <MenuIcon className='icon' />}
                    </div>
                )}
            </div>
            {menuOpen ? (
                <div className='responsive-menu-container'>
                    {(location.pathname.includes(ENDPOINT.homepage) ||
                        publicPathName?.some((item: any) =>
                            location.pathname.toLowerCase().includes(item.toLowerCase())
                        )) &&
                        !isMobileSubMenuOpen && (
                            <div>
                                <Divider
                                    className='hamdivider'
                                    sx={{
                                        display: 'flex',
                                        margin: '1% 2% 0% 2%'
                                    }}
                                />
                                {menuItems.map((option, index) => (
                                    <div
                                        className='menu-name'
                                        onClick={(e) => handleMenuClick(e, option.goto)}
                                        key={index}
                                    >
                                        <Box sx={{fontSize: '16px', fontWeight: '500'}} className='menuText'>
                                            {option.name}
                                            {option.name === 'Why CPS' && (
                                                <Box id='ExpandIcon' sx={{alignItems: 'flex-end'}}>
                                                    <img
                                                        src={Chevron}
                                                        className='listExpandMore'
                                                        alt='ExpandLessIcon'
                                                    />
                                                </Box>
                                            )}
                                        </Box>
                                        {index !== menuItems.length - 1 && (
                                            <Divider
                                                className='hamdivider'
                                                sx={{
                                                    display: 'flex',
                                                    margin: '1% 2% 0% 2%'
                                                }}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    {isMobileSubMenuOpen ? (
                        <Slide
                            direction='left'
                            in={isMobileSubMenuOpen}
                            mountOnEnter
                            unmountOnExit
                            timeout={{enter: 700, exit: 100}}
                            easing='cubic-bezier(0.22, 1, 0.36, 1)'
                        >
                            <div id='homepage-submenu-mobile-root' className='homepage-submenu-mobile'>
                                <div className='submenu-text mainMenuHeader' onClick={toggleSubMenu(false)}>
                                    <span>
                                        <img src={Chevron} className='ExpandLessMenuIcon' alt='ExpandMoreIcon' />
                                    </span>
                                    <span className='MainMenuText'>Main Menu</span>
                                </div>
                                <div className='submenu-title mainMenuHeader'>Why CPS</div>
                                {subMenuItems?.map((subMenuItem) => (
                                    <div
                                        key={subMenuItem.id}
                                        className='submenu-text submenu-text-innercontainer'
                                        onClick={(e) => {
                                            if (window.pageYOffset <= 0) {
                                                window.scrollTo({
                                                    top: 2000
                                                })
                                            }
                                            handleMenuClick(e, subMenuItem.goto)
                                        }}
                                    >
                                        {subMenuItem.name}
                                    </div>
                                ))}
                            </div>
                        </Slide>
                    ) : null}
                    <div className='menu-container2'>
                        <Link component='button' onClick={handleLoginClick} className='goToLogin'>
                            <AccountCircleIcon className='login-icon' />
                            <span className='loginTxt'>Log in</span>
                        </Link>
                        <Button className='registrationBtn' onClick={() => handleRegistrationClick()}>
                            Register
                        </Button>
                    </div>
                </div>
            ) : null}
        </>
    )
}

export default MenuColection
